import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";

import ContinuousCosts from "components/CreateWizard/Costs/ContinuousCosts";

class ContinuousCostsContainer extends React.PureComponent {
  render() {
    const { step, index, isShow } = this.props;

    return <ContinuousCosts {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateStep: (step) => dispatch(updateStep(step)),
  updateConversionGain: (conversionGain) => dispatch(setupReducer.updateConversionGain(ownProps.id, conversionGain)),
  updateConversionCost: (conversionCost) => dispatch(setupReducer.updateConversionCost(ownProps.id, conversionCost)),
  updateConversionMissed: (conversionMissed) =>
    dispatch(setupReducer.updateConversionMissed(ownProps.id, conversionMissed)),
  updateConversionSaved: (conversionSaved) =>
    dispatch(setupReducer.updateConversionSaved(ownProps.id, conversionSaved)),

  updateThreshold: (threshold) => dispatch(setupReducer.updateThreshold(ownProps.id, threshold)),

  updateTimePeriod: (timePeriod) => dispatch(setupReducer.updateTimePeriod(ownProps.id, timePeriod)),

  updateIsHideCounts: (isHideCounts) => dispatch(setupReducer.updateIsHideCounts(ownProps.id, isHideCounts))
});

const mapStateToProps = (state, ownProps) => ({
  conversionGain: setupReducer.getConversionGain(state, ownProps.id),
  conversionCost: setupReducer.getConversionCost(state, ownProps.id),

  threshold: setupReducer.getThreshold(state, ownProps.id),

  isContinuous: setupReducer.getOutcomeType(state, ownProps.id) === "number",

  outcome: setupReducer.getOutcomeFromDataset(state, ownProps.id),
  success: setupReducer.getSuccessValue(state, ownProps.id),

  timePeriod: setupReducer.getTimePeriod(state, ownProps.id),

  isHideCounts: setupReducer.getIsHideCounts(state, ownProps.id),

  step: getStep(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ContinuousCostsContainer);
